import React from 'react'
import {Paper, Box,CircularProgress,Typography} from '@deere/fuel-react'


export const CircularIndicator = ({message,details}) => {
    return (
        <Paper variant="outlined">
            <Box
                alignItems="center"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                px={10}
                py={30}
            >
                <CircularProgress size="lg" />
                <Typography
                    style={{
                        marginTop: "1.5rem",
                        marginBottom: "0.5rem",
                    }}
                    variant="h1"
                >
                    {message}
                </Typography>
                <Typography variant="body2">
                    {details}
                </Typography>
            </Box>
        </Paper>
    );
}